/* ==========================================================================
   CLARITY HEALTH CO — FAQ accordion
   Independent question/answer rows: each toggles on its own (several can be open).
   Keeps aria-expanded (button) and aria-hidden (panel) in sync. Native <button>
   triggers, so keyboard and focus work for free. Lightweight, no dependencies.
   ========================================================================== */
(function () {
  function wire(section) {
    if (section.dataset.faqWired === '1') return;
    var items = Array.prototype.slice.call(section.querySelectorAll('.clarity-faq__item'));
    if (!items.length) return;
    section.dataset.faqWired = '1';

    items.forEach(function (item) {
      var btn = item.querySelector('.clarity-faq__btn');
      var panel = item.querySelector('.clarity-faq__panel');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        panel.setAttribute('aria-hidden', String(!open));
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-clarity-faq]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target || document;
    var section = t.querySelector ? t.querySelector('[data-clarity-faq]') : null;
    if (section) wire(section);
  });
})();
